import {
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {KlasifikatoriusApi} from "../api/klasifikatorius.api";
import {TranslateService} from "@ngx-translate/core";
import {GridDataResult} from "@progress/kendo-angular-grid";
import {State} from "@progress/kendo-data-query";
import {Observable} from "rxjs";
import {SharedDataService} from "../service/shared-data.service";
import {LanguageService} from "../service/language.service";
import {GiiApskaitaFilterApi} from '../api/gii-apskaita-filter.api';
import {GiiAtaskaitaService} from '../service/gii-ataskaita.service';
import {AtaskPerziuraService} from '../service/atask-perziura.service';
import {Router} from '@angular/router';
import {reportsList} from "../enums/reports-enum";
import {AtaskaitosParametraiApi} from '../api/ataskaitos-parametrai.api';
import {KlasifikatoriusService} from "../service/klasifikatorius.service";

@Component({
  selector: 'gii-apskaita',
  templateUrl: './gii-apskaita.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./gii-apskaita.component.css'],
})
export class GiiApskaitaComponent implements OnInit {
  public page = 0;
  public pageSize = 20;
  public view: Observable<GridDataResult>;
  public showExportDialog = false;
  reports: any = reportsList;

  apskaitaFilter = new GiiApskaitaFilterApi();
  dokumentoTipasList: { text: string; value: string | null }[] = [];
  busenosList: { text: string; value: string | null }[] = [];
  vidinesBusenosList: { text: string; value: string | null }[] = [];
  subjektoTipasList: { text: string; value: string | null }[] = [];
  atsakomybesBudasList: { text: string; value: string | null }[] = [];
  orderByList: any[] = [{}];
  orderByListSecond: any[] = [{}];
  orderByListThird: any[] = [{}];
  currentYear: number = new Date().getFullYear();
  years: Array<string> = [];
  ataskaitosParametrai = new AtaskaitosParametraiApi((new Date().getFullYear() - 1).toString());

  klasifikatoriusList: KlasifikatoriusApi[] = [];
  public state: State = {
    skip: 0,
    take: 20,
  };

  constructor(private translate: TranslateService,
              private router: Router,
              public giiAtaskaitaService: GiiAtaskaitaService,
              public ataskPerziuraService: AtaskPerziuraService,
              public sharedDataService: SharedDataService,
              private languageService: LanguageService,
              private klasifikatoriusService: KlasifikatoriusService) {
    this.view = giiAtaskaitaService;
    this.ataskaitosParametrai.registracijosDataNuo = new Date('2024-04-01')
    this.ataskaitosParametrai.registracijosDataIki = new Date();
    this.giiAtaskaitaService.queryFilteredGiiAtask(this.apskaitaFilter);
  }

  ngOnInit(): void {
    this.sharedDataService.getklasifikatoriusApiSubject().subscribe((data: KlasifikatoriusApi[]) => {
      this.klasifikatoriusList = data;
    });
    this.populateYears();
    this.refreshLists();

    this.translate.onLangChange.subscribe((event) => {
      this.refreshLists()
    });
  }

  private refreshLists(): void {
    this.updateDokumentoTipasList();
    this.updateSubjektoTipasList();
    this.updateBusenosList();
    this.updateVidinesBusenosList();
    this.atsakomybesBudasList = this.klasifikatoriusService.prepareClFilterList(this.klasifikatoriusList, 'CL124', 'IN');
    this.updateOrderByList();
  }

  updateOrderByList() {
    this.orderByList = [
      { text: '', value: null },
      { text: this.translate.instant('apskaita.orderBy.regData.desc'), value: 'REGDATA_DESC' },
      { text: this.translate.instant('apskaita.orderBy.regData.asc'), value: 'REGDATA_ASC' },
      { text: this.translate.instant('apskaita.orderBy.subjektas.desc'), value: 'SUBJEKTAS_DESC' },
      { text: this.translate.instant('apskaita.orderBy.subjektas.asc'), value: 'SUBJEKTAS_ASC' },
      { text: this.translate.instant('apskaita.orderBy.busenosData.desc'), value: 'BUSENOS_DATA_DESC' },
      { text: this.translate.instant('apskaita.orderBy.busenosData.asc'), value: 'BUSENOS_DATA_ASC' },
      { text: this.translate.instant('apskaita.orderBy.metai.desc'), value: 'METAI_DESC' },
      { text: this.translate.instant('apskaita.orderBy.metai.asc'), value: 'METAI_ASC' }
    ];
  }

  updateDokumentoTipasList() {
    this.dokumentoTipasList = [
      { text: '', value: null },
      { text: this.translate.instant('enum.dokumentoTipas.ORO_BALIONELIU_ATASKAITA'), value: 'ORO_BALIONELIU_ATASKAITA' },
      { text: this.translate.instant('enum.dokumentoTipas.SERVETELIU_ATASKAITA'), value: 'SERVETELIU_ATASKAITA' },
      { text: this.translate.instant('enum.dokumentoTipas.TABAKO_FILTRU_ATASKAITA'), value: 'TABAKO_FILTRU_ATASKAITA' },
    ];
  }

  updateSubjektoTipasList() {
    this.subjektoTipasList = [
      { text: '', value: null },
      { text: this.translate.instant('label.tipas.FA'), value: 'FA' },
      { text: this.translate.instant('label.tipas.JA'), value: 'JA' },
      { text: this.translate.instant('label.tipas.UZ'), value: 'UZ' },
    ];
  }

  updateBusenosList() {
    this.busenosList = [
      { text: '', value: null },
      { text: this.translate.instant('enum.ataskaitosBusena.RENGIAMA'), value: 'RENGIAMA' },
      { text: this.translate.instant('enum.ataskaitosBusena.PRIIMTA'), value: 'PRIIMTA' },
      { text: this.translate.instant('enum.ataskaitosBusena.NEPRIIMTA'), value: 'NEPRIIMTA' },
    ];
  }

  updateVidinesBusenosList() {
    this.vidinesBusenosList = [
      { text: '', value: null },
      { text: this.translate.instant('enum.vidineAtaskaitosBusena.TIKRINAMA'), value: 'TIKRINAMA' },
      { text: this.translate.instant('enum.vidineAtaskaitosBusena.TIKRINTINA'), value: 'TIKRINTINA' },
      { text: this.translate.instant('enum.vidineAtaskaitosBusena.PATIKRINTA'), value: 'PATIKRINTA' },
      { text: this.translate.instant('enum.vidineAtaskaitosBusena.NERA'), value: 'NERA' },
    ];
  }

  onRowSelect(row: any): void {
    this.ataskPerziuraService.openAtaskPerziura(row);
  }

  onFilterClicked(): void {
    this.page = 0;
    this.state.skip = 0;
    this.apskaitaFilter.page = this.page;
    this.apskaitaFilter.pageSize = this.pageSize;
    this.giiAtaskaitaService.queryFilteredGiiAtask(this.apskaitaFilter);
  }

  onPageChanged(event: any): void {
    this.state.skip = event.skip;
    this.pageSize = event.take;
    this.page = (event.skip / this.pageSize);
    this.apskaitaFilter.page = this.page;
    this.apskaitaFilter.pageSize = this.pageSize;
    this.giiAtaskaitaService.queryFilteredGiiAtask(this.apskaitaFilter);
  }

  filterOrderBy2(orderBy: string, orderBy3: string): void {
    const empty = null;
    if (orderBy) {
      this.orderByListSecond = this.orderByList.filter((item) => item.value == null || !item.value.includes(orderBy.split("_")[0]));
      this.apskaitaFilter.orderBySecond = empty;
      this.apskaitaFilter.orderByThird = empty;
    } else {
      this.orderByListSecond = [{}];
      this.apskaitaFilter.orderBySecond = empty;
      if (orderBy3) {
        this.orderByListThird = [{}];
        this.apskaitaFilter.orderByThird = empty;
      }
    }
  }
  filterOrderBy3(orderBy: string, orderBy2: string): void {
    const empty = null;
    if (orderBy2) {
      this.orderByListThird = this.orderByList.filter((item) => item.value == null || (item.value && !item.value.includes(orderBy2.split("_")[0]) && !item.value.includes(orderBy.split("_")[0])));
      this.apskaitaFilter.orderByThird = empty;
    } else {
      this.orderByListThird = [{}];
      this.apskaitaFilter.orderByThird = empty;
    }
  }

  openExportDialog(): void {
    this.showExportDialog = true;
  }

  closeExportDialog(): void {
    this.showExportDialog = false;
  }

  populateYears(): void {
    const startYear = 2023;
    this.years.push('');
    for (let year = startYear; year <= this.currentYear; year++) {
      this.years.push(year.toString());
    }
  }
}
